import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import {
  faAngleDown,
  faAngleUp,
  faArrowAltCircleLeft,
  faArrowAltCircleRight,
  faArrowCircleLeft,
  faArrowCircleRight,
  faArrowDown,
  faArrowUp,
  faArrowLeft,
  faArrowRight,
  faArrowsAlt,
  faAsterisk,
  faBan,
  faBars,
  faBell,
  faBug,
  faBook,
  faBox,
  faImage,
  faCalendarAlt,
  faCheck,
  faCheckCircle,
  faChevronDown,
  faChevronUp,
  faClock,
  faCloud,
  faCopy,
  faCropSimple,
  faDatabase,
  faEdit,
  faEllipsisV,
  faEnvelope,
  faEye,
  faFile,
  faFileArchive,
  faFileAudio,
  faFileCode,
  faFileDownload,
  faFileExcel,
  faFileImage,
  faFileLines,
  faFilePdf,
  faFilePowerpoint,
  faFileVideo,
  faFileWord,
  faFlag,
  faHdd,
  faHeart,
  faHome,
  faIdCard,
  faInfo,
  faList,
  faLock,
  faMinus,
  faPaperclip,
  faPause,
  faPencilAlt,
  faPhotoVideo,
  faPlay,
  faPlayCircle,
  faPlus,
  faProjectDiagram,
  faQrcode,
  faQuestion,
  faQuestionCircle,
  faRoad,
  faSave,
  faSearch,
  faSignInAlt,
  faSignOutAlt,
  faSort,
  faSortDown,
  faSortUp,
  faSpellCheck,
  faSpinner,
  faStar,
  faStop,
  faStopCircle,
  faSync,
  faTachometerAlt,
  faTasks,
  faThList,
  faTimes,
  faTimesCircle,
  faTrash,
  faTrashAlt,
  faUpload,
  faUser,
  faUserCircle,
  faUserPlus,
  faUsers,
  faUserSecret,
  faWrench,
  faStream,
  faCodeBranch,
  faArchive,
  faGripVertical,
  faTable,
  faGlobe,
  faCog,
  faExclamationCircle,
  faCalendar,
  faCheckSquare as faCheckSquareSolid,
  faLink,
  faChartLine,
  faRandom,
  faBriefcase,
  faBezierCurve,
  faRoute,
  faReply,
  faPlug,
  faWaveSquare,
  faMap,
  faScrewdriver,
  faStopwatch,
  faStopwatch20,
  faHand,
  faHandsHelping,
  faMousePointer,
  faHandPointer,
  faChessBoard,
  faWindowClose,
  faWindowMaximize,
  faWindowMinimize,
  faWindowRestore,
  faHouse,
  faClipboardList,
  faGraduationCap,
  faListCheck,
  faBolt,
  faDumbbell,
  faPersonChalkboard,
  faPeopleArrows,
  faCircleCheck,
  faUserGear,
  faStamp,
  faPaperPlane,
  faChartColumn,
  faSliders,
  faCalendarDays,
  faClipboardCheck,
  faCircleInfo,
  faTableCells,
  faAward,
  faGaugeHigh,
  faUsersGear,
  faShieldHalved,
  faPhotoFilm,
  faBoxArchive,
  faCheckDouble,
  faWandMagicSparkles,
} from '@fortawesome/free-solid-svg-icons';
import {
  faArrowAltCircleRight as faArrowAltCircleRightRegular,
  faCheckCircle as faCheckCircleRegular,
  faCheckSquare,
  faFile as faFileRegular,
  faFolder,
  faStickyNote as faStickyNoteRegular,
} from '@fortawesome/free-regular-svg-icons';

export function initFontAwesome(library: FaIconLibrary): void {
  // Solid icons
  library.addIcons(
    faUser,
    faSort,
    faSortUp,
    faSortDown,
    faSpinner,
    faSync,
    faEye,
    faEllipsisV,
    faBan,
    faTimes,
    faArrowLeft,
    faSpellCheck,
    faPhotoVideo,
    faSave,
    faPlus,
    faPencilAlt,
    faBars,
    faHome,
    faUpload,
    faThList,
    faUserPlus,
    faRoad,
    faCodeBranch,
    faTachometerAlt,
    faHeart,
    faList,
    faBell,
    faTasks,
    faBook,
    faHdd,
    faFlag,
    faWrench,
    faLock,
    faCloud,
    faStream,
    faSignOutAlt,
    faSignInAlt,
    faCalendarAlt,
    faSearch,
    faTrashAlt,
    faAsterisk,
    faArrowsAlt,
    faPaperclip,
    faCopy,
    faCropSimple,
    faTimesCircle,
    faClock,
    faProjectDiagram,
    faFileVideo,
    faFileImage,
    faFileAudio,
    faFileWord,
    faFileExcel,
    faFilePowerpoint,
    faFileCode,
    faFileArchive,
    faFileLines,
    faTrash,
    faArrowRight,
    faMinus,
    faArrowDown,
    faArrowUp,
    faFile,
    faArrowAltCircleLeft,
    faArrowAltCircleRight,
    faEnvelope,
    faChevronDown,
    faChevronUp,
    faEdit,
    faCheck,
    faQuestion,
    faQuestionCircle,
    faDatabase,
    faBox,
    faStar,
    faPlayCircle,
    faStopCircle,
    faArrowCircleLeft,
    faArrowCircleRight,
    faAngleDown,
    faAngleUp,
    faFilePdf,
    faIdCard,
    faUserCircle,
    faQrcode,
    faUserSecret,
    faUsers,
    faInfo,
    faCheckCircle,
    faPlay,
    faStop,
    faPause,
    faFileDownload,
    faArchive,
    faImage,
    faGripVertical,
    faExclamationCircle,
    faRandom,
    faBriefcase,
    faBezierCurve,
    faRoute,
    faReply,
    faPlug,
    faWaveSquare,
    faStopwatch,
    faStopwatch20,
    faScrewdriver,
    faHand,
    faHandsHelping,
    faMousePointer,
    faHandPointer,
    faChessBoard,
    faWindowClose,
    faWindowMaximize,
    faWindowMinimize,
    faWindowRestore,
    faTable,
    faGlobe,
    faCog,
    faCalendar,
    faCheckSquareSolid,
    faLink,
    faChartLine,
    faMap,
    faHouse,
    faClipboardList,
    faGraduationCap,
    faListCheck,
    faBolt,
    faDumbbell,
    faPersonChalkboard,
    faPeopleArrows,
    faCircleCheck,
    faUserGear,
    faStamp,
    faPaperPlane,
    faChartColumn,
    faSliders,
    faCalendarDays,
    faClipboardCheck,
    faCircleInfo,
    faTableCells,
    faAward,
    faGaugeHigh,
    faUsersGear,
    faShieldHalved,
    faPhotoFilm,
    faBoxArchive,
    faCheckDouble,
    faBug,
    faWandMagicSparkles,
  );

  // Regular icons
  library.addIcons(faFolder, faCheckSquare, faArrowAltCircleRightRegular, faCheckCircleRegular, faStickyNoteRegular, faFileRegular);
}
